export const environment = {
  production: true,
  APIProtocol: 'https://',
  APIIp: 'telecontrollo.pradella.it',
  APIPort: '443',
  APIContext: '/iot/api',
  typeOfEnv: 'prod'
};
